<template>
    <div>
        <transition name="fade">
            <div v-if="loading" class="loading">
                <p>Loading</p>
            </div>
        </transition>
        <b-container fluid>
            
            <!-- Download Orders CSV -->
            <h4 style="margin-top:20px">Download a CSV of Orders</h4>
            <!-- Custom Date -->
            <b-row >
                <b-col md='2'>
                    <div  style="width:250px; color:green">
                        <b-form-group
                            id="fieldset-19"
                            label="Start Date"
                            label-for="input-date1"
                            >
                            <b-form-datepicker  size="sm" @input="dateChanged" value-as-date id="example-datepicker1" :max="maxDate" v-model="customDateStart" class="mb-2"></b-form-datepicker>
                        </b-form-group>
                    </div>
                </b-col>
                <b-col>
                    <div  style="width:250px; color:green">
                        <b-form-group
                            id="fieldset-20"
                            label="End Date"
                            label-for="input-date2"
                            >
                            <b-form-datepicker  size="sm" @input="dateChanged" value-as-date id="example-datepicker2" :max="maxDate" v-model="customDateStop" class="mb-2"></b-form-datepicker>
                        </b-form-group>
                    </div>
                </b-col>
            </b-row>
            <download-csv
                :data="csvOrdersData">
                <b-button  size="sm">Download Sales CSV</b-button>
            </download-csv>
            <hr>
                
                    <b-row>
                        <b-col>
                            <b-button style="margin-top:10px" :disabled="ordersToInvoice.length<1"  class="btn btn-secondary"  variant="info" type="button" @click="submitForInvoicing()"> 
                                Create Invoices for Selected Orders
                            </b-button>
                        </b-col>
                    </b-row>

                    <br>
                    <!-- New orders -->
                    <b-row v-if="newOrders.length>0">
                        <b-col>
                            <div class="input-group" style='margin-top:10px; margin-bottom:10px; margin-left:10px'>
                                <b-button size="" squared  variant="success" v-b-toggle.collapse-neworders class="btn btn-secondary" type="button">NEW ORDERS</b-button>
                                    <div class="input-group-append">
                                        <b-button v-b-toggle.collapse-neworders class="btn btn-secondary"  variant="success" type="button"> 
                                            <font-awesome-icon icon="caret-down" />
                                        </b-button>
                                    </div>
                                </div>
                            <b-collapse visible id="collapse-neworders">
                                <Brewerorderscomponent  :ordersArray="newOrders" :status = 0 :addToInvoicesArray="addToInvoicesArray" :removeFromInvoicesArray="removeFromInvoicesArray"/>
                            </b-collapse>
                        </b-col>
                    </b-row>
                    <b-row v-else><h3><i>No new orders at this time</i></h3></b-row>
                    <hr>

                    <!-- Active Orders -->
                    <b-row v-if="activeOrders.length>0">
                        <b-col>
                            <div class="input-group" style='margin-top:10px; margin-bottom:10px; margin-left:10px'>
                                <b-button  variant="success" squared v-b-toggle.collapse-activeorders class="btn btn-secondary" type="button">AWAITING DELIVERY</b-button>
                                    <div class="input-group-append">
                                        <b-button v-b-toggle.collapse-activeorders variant="success" class="btn btn-secondary" type="button"> 
                                            <font-awesome-icon icon="caret-down" />
                                        </b-button>
                                    </div>
                            </div>
                            <b-collapse visible id="collapse-activeorders">
                                <Brewerorderscomponent  :ordersArray="activeOrders" :status = 1 :addToInvoicesArray="addToInvoicesArray" :removeFromInvoicesArray="removeFromInvoicesArray"/>
                            </b-collapse>
                        </b-col>
                    </b-row>
                    <b-row v-else><h3><i>No active orders at this time</i></h3></b-row>
                    <hr>

                    <!-- Past orders -->
                    <b-row v-if="pastOrders.length>0">
                        <b-col>
                            <div class="input-group" style='margin-top:10px; margin-bottom:10px; margin-left:10px'>
                                <b-button  variant="success" squared v-b-toggle.collapse-pastorders class="btn btn-secondary" type="button">PAST ORDERS</b-button>
                                    <div class="input-group-append">
                                        <b-button v-b-toggle.collapse-pastorders variant="success" class="btn btn-secondary" type="button"> 
                                            <font-awesome-icon icon="caret-down" />
                                        </b-button>
                                    </div>
                            </div>
                            <b-collapse visible id="collapse-pastorders">
                                <Brewerorderscomponent  :ordersArray="pastOrders" :status = 2 :addToInvoicesArray="addToInvoicesArray" :removeFromInvoicesArray="removeFromInvoicesArray"/>
                            </b-collapse>
                        </b-col>
                    </b-row>
                    <b-row v-else><h3><i>No past orders to show</i></h3></b-row>
                    
                    <b-row>
                        <b-col>
                            <b-button style="margin-top:50px" :disabled="ordersToInvoice.length<1"  class="btn btn-secondary"  variant="info" type="button" @click="submitForInvoicing()"> 
                                Create Invoices for Selected Orders
                            </b-button>
                        </b-col>
                    </b-row>

                <!-- Consumer tab -->
                <!--
                <b-tab>
                    <template v-slot:title>
                        <strong>CONSUMERS</strong>
                    </template>
                    <Breweryconsumerordercomponent  :ordersArray="breweryConsumerOrders" />
                </b-tab>
                -->

        </b-container>
        <footer><pagefooter/></footer>
        
    </div>
</template>

<script>
    import { mapState } from 'vuex'
    import Brewerorderscomponent from './Brewerorderscomponent'
    import Breweryconsumerordercomponent from './seller/Breweryconsumerordercomponent'
    const fb = require('../firebaseConfig.js')
    import {timeConverter} from './Myfunctions'
    import {timeConverterObject} from './Myfunctions'
    import {timeConverterDateOnly} from './Myfunctions'
    import {createArrayToInvoice} from './Morefunctions'
    import Pagefooter from './Pagefooter'

    export default {
        components: {
            Brewerorderscomponent,
            Pagefooter,
            Breweryconsumerordercomponent,
            },
        computed: {
            ...mapState(['userProfile', 'currentUser', 'newOrders', 'activeOrders', 'pastOrders', 'ordersToInvoice', 'breweryConsumerOrders', 'allBreweryOrders'])
        },
        data() {
            return {       
                loading:false,    
                maxDate:'',
                customDateStart:'',
                customDateStop:'',
                csvOrdersData:[],

            }
        },

        methods:{
            showPastOrders(){
                this.loading=true

                var localPastOrders = []
                fb.ordersCollection.where('brewerid','==',this.currentUser.uid).orderBy("createdOn", "desc").get().then(docs => {
                    docs.forEach(doc => {
                    var order = doc.data()
                    if (order.createdOn) {
                        order.orderDate = timeConverterDateOnly(order.createdOn.seconds)
                        order.dateObject = timeConverterObject(order.createdOn.seconds)
                    }
                    //Check order status
                    switch(parseInt(order.status)) {
                        case -1:
                            if(order.cancelledBy == 0){
                                var adStr = order.brewer
                                }
                            else{
                                var adStr = order.pub
                                }
                            order.displayStatus="Cancelled by " + adStr
                            localPastOrders.push(order)
                            this.$store.commit('setPastOrders', localPastOrders)
                            break;                                
                        case 2:
                            order.displayStatus="On It's Way!"
                            if(parseInt(order.isPaid)==1) order.isPaid = 1
                            localPastOrders.push(order)
                            this.$store.commit('setPastOrders', localPastOrders)
                            break;
                        default:
                            order.displayStatus="Unknown"

                    }
                      
                })
                    }).then(res => {
                        this.loading=false
                        this.$router.push({name:'pastorders'})

                    })
            },
            //To add to invoices array
            addToInvoicesArray(order){
                order.selected=1
                var theOrders=this.ordersToInvoice
                //Check if order already in array
                const existingOrderindex = theOrders.findIndex(item => item.suborderid === order.suborderid);
                if(existingOrderindex<0){
                    theOrders.push(order)
                    this.$store.commit('setOrdersToInvoice',theOrders)
                }
                


            },
            //Remove from invoices array when user unchecks
            removeFromInvoicesArray(order){
                order.selected=0
                var theOrders=this.ordersToInvoice
                const existingOrderindex = theOrders.findIndex(item => item.suborderid === order.suborderid);
                if(existingOrderindex>-1){
                    console.log("Found order to remove")
                    theOrders.splice(existingOrderindex, 1)
                } 
                else console.log("Unable to remove order")
                this.$store.commit('setOrdersToInvoice',theOrders)


            },
            //Submit for invoicing
            submitForInvoicing(){
                var groupedArray=createArrayToInvoice(this.ordersToInvoice, this.userProfile.company)
                //End of orders array
                this.$store.commit('setInvoicesArray',groupedArray)

                this.$router.push({ path: 'invoicescreated'})

            },

            //Date changed for orders
            dateChanged(){
                this.createOrdersCSV()

            },

            //Create sale CSV
            createOrdersCSV(){
                var startTime = (new Date(this.customDateStart)).getTime();
                //Iterate over orders
                var tempArray=[]
                for (var i=0; i<this.allBreweryOrders.length; i++){
                    var thisOrder = this.allBreweryOrders[i]
                    var orderToAdd={}
                    var orderDate = thisOrder.createdOn.seconds*1000
                    if (orderDate>=this.customDateStart.getTime()&&orderDate<=this.customDateStop.getTime()) {
                        orderToAdd.date = timeConverterDateOnly(orderDate/1000)
                        orderToAdd.buyer = thisOrder.pub
                        orderToAdd.product = thisOrder.beerName
                        orderToAdd.container = thisOrder.size
                        orderToAdd.quantity = thisOrder.quantity
                        orderToAdd.cost = thisOrder.cost
                        if(thisOrder.status==-1) orderToAdd.status="Cancelled"
                        if(thisOrder.status==0) orderToAdd.status="Pending"
                        if(thisOrder.status==1) orderToAdd.status="Accepted"
                        if(thisOrder.status==2) orderToAdd.status="Delivered"
                        tempArray.push(orderToAdd)
                    }

                }
                this.csvOrdersData=tempArray
            }


        },
        mounted(){
            const maxDate = new Date()
            this.maxDate=maxDate
            var minDate = new Date()
            minDate.setMonth(minDate.getMonth() - 1)
            this.customDateStop=maxDate
            this.customDateStart=minDate
            this.createOrdersCSV()
        },
        
    }
</script>